import { cn } from "@tellescope/ui";
import type { TextBlock as TextBlockType } from "../../../shared/schema";

interface TextBlockProps {
  content: TextBlockType["props"]["content"];
  variant: TextBlockType["props"]["variant"];
}

const variantStyles: Record<TextBlockType["props"]["variant"], string> = {
  body: "text-base text-foreground",
  caption: "text-sm text-muted-foreground",
  muted: "text-base text-muted-foreground",
};

export const TextBlock: React.FC<TextBlockProps> = ({ content, variant = "body" }) => {
  if (!content) return null;

  return (
    <p
      className={cn(variantStyles[variant], "whitespace-pre-wrap")}
      style={{ fontFamily: "var(--portal-body-font, inherit)" }}
    >
      {content}
    </p>
  );
};
